export default __webpack_public_path__ + "static/media/pizzo.4257193e.webp";